import { Icon, IconType } from "assets/icons";

import { ContentWrapper, PaddingConfig } from "components/ContentWrapper";
import { Paragraph } from "components/Paragraph/Paragraph";

import styles from "./styles.module.scss";

type MenuItemProps = {
  name: string;
  icon?: IconType;
  onClick?: VoidFunction;
  isActive?: boolean;
};

const PADDING: PaddingConfig = {
  paddingTop: 8,
  paddingBottom: 8,
};

export const MenuItem = (props: MenuItemProps): JSX.Element => {
  const { icon, name, onClick, isActive } = props;
  return (
    <ContentWrapper
      paddingConfig={PADDING}
      className={`hoverBg cursor-pointer menuItem ${isActive ? styles.isActive : ""}`}
      onClick={onClick}
    >
      <div className="flex justify-start items-center relative">
        <div className="absolute left-0">
          {!!icon ? <Icon size={20} type={icon} /> : <div className="w-1" />}
        </div>
        <Paragraph className="pl-9">{name}</Paragraph>
      </div>
    </ContentWrapper>
  );
};
